import ViewMapping from './ViewMapping.js';

class ViewMap {

	/**
	 * @param {Context} context
	 */
	constructor(context) {
		this.context = context;
		this.mappings = [];
	}

	/**
	 * @param {String} selector
	 * @param {View} ViewClass
	 * @param {ViewMediator} [ViewMediatorClass]
	 *
	 * @return {ViewMapping}
	 */
	map(selector, ViewClass, ViewMediatorClass) {
		if (!ViewClass) {
			throw new Error('The supplied view for selector "' + selector + '" is undefined.');
		}

		var mapping = new ViewMapping(this.context, selector, ViewClass, ViewMediatorClass);
		this.mappings.push(mapping);

		return mapping;
	}

	/**
	 * Build all registered mappings
	 *
	 * @return {ViewMap}
	 */
	build() {
		for (let i = 0; i < this.mappings.length; i++) {
			this.mappings[i].build();
		}

		return this;
	}

	/**
	 * Destroy all views created by it's mappings. It does not however,
	 * remove the mappings themselves.
	 *
	 * @return {ViewMap}
	 */
	destroy() {
		for (let i = 0; i < this.mappings.length; i++) {
			this.mappings[i].destroy();
		}

		return this;
	}

	/**
	 * @returns {Array|ViewMapping[]}
	 */
	getMappings() {
		return this.mappings;
	}

	/**
	 * @returns {String}
	 */
	toString() {
		return '[object ViewMap]';
	}
}

export default ViewMap;


// WEBPACK FOOTER //
// ./js/Core/ViewMap.js